<style scoped="scoped" lang="scss">
	.container {
		padding-left: 24px;
		padding-right: 24px;
		overflow: auto;

		.box {
			padding: 0;

			.txt {
				margin-left: 5px;
			}

			li {
				display: inline-block;
				line-height: 1;
				white-space: nowrap;
				cursor: pointer;
				background: #fff;
				border: 1px solid #dcdfe6;
				color: #606266;
				-webkit-appearance: none;
				text-align: center;
				box-sizing: border-box;
				outline: none;
				margin: 0 30px 10px 0px;
				transition: 0.1s;
				font-weight: 500;
				padding: 7px 15px;
				font-size: 12px;
				border-radius: 3px;
				// margin-left: 10px;
			}

			li.checked {
				background-color: #FEF0F0;
				color: #F56C6C;
				border: 1px #FDE2E2 solid;
			}
		}

		li.checked {
			// background-color: #b3d8ff;
			color: #409eff;
			border: 1px #b3d8ff solid;
		}
	}
</style>

<template>
	<div style="display: inline;">
		<yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt" getKey="rows">
		</yi_curd_table>
		<div class="container">
			<div class="form">
				<div>
					<div style="margin-bottom: 15px; color:#303133;font-size: 16px;font-family:'PingFang SC';">
						{{$t('yichangleixingmingcheng')}}
					</div>
					<ul class="box">
						<li v-for="(item, index) in exceptionTypeList" :key="index"
							:class="{ checked: index == selectIndex }" @click="selectBtn(item, index)">
							<span>{{ item.name }}</span>
						</li>
					</ul>
				</div>
				<div style="margin-top: 40px;">
					<el-form size="mini" :model="conditions" :inline="true">
						<el-form-item :label="$t('shebeimingcheng')" required>
							<yi_cross_select :component="'web_base_equipment_list'" :max="1"
								:ids.sync="conditions.equipmentId">
							</yi_cross_select>
						</el-form-item><br/>
						<el-form-item style="margin-left: 10px;" :label="$t('yichangmiaoshu')">
							<el-input v-model="conditions.description"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div style="margin-top: 20px;">
					<el-button @click="trigger" type="danger" size="mini" :loading="triggerLoading" v-if="utils.checkPower('web_andon_management_trigger_exception_create')">
						{{$t('chufayichang')}}
					</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_andon_management_trigger_exception_index',
		components: {

		},
		data() {
			return {
				triggerLoading: false,
				conditions: {},
				selectItem: {
					id: "",
				},
				selectIndex: -1,
				exceptionTypeList: []
			};
		},

		created() {
			setTimeout(() => {
				this.getExceptionType()
				// this.yt.get(1)
			}, 300)
		},
		methods: {
			selectBtn(item, index) {
				if (index == this.selectIndex) {
					this.selectIndex = -1;
				} else {
					this.selectIndex = index;
					this.selectItem = item;
				}
				console.log('this.selectItem', this.selectItem.id)
			},
			trigger() {
				this.triggerLoading = true;
				this.http.post('/web/andon/record/create', {
					exceptionTypeId: this.selectItem.id,
					...this.conditions
				}).then(res => {
					this.utils.successMessage(this.$t(res.msg));
					if (res.msg) {
						this.conditions = {}
						this.selectIndex = -1;
						this.selectItem.id = null
					}
				}).catch((msg) => {
					this.utils.errorMessage(msg);
				}).finally(() => {
					this.triggerLoading = false;
				});
			},
			getExceptionType() {
				this.http.get('/web/andon/exceptionType/page', {
					params: {
						status: 1,
						pageNum: 1,
						pageSize: 1000
					}
				}).then(res => {
					this.exceptionTypeList = res.data.rows
				})

			}
		}
	};
</script>
